import type { FIXED_INDENTS } from 'vars/index'
import type { IPINCodeField } from './PINCodeField'
import type { IPINCodeInput } from './PINCodeInput'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { COLOR } from 'vars/index'
import { PopupDirection } from '../../Popup.h'

export const ErrorLayoutSC = styled.div`
  position: relative;
  height: 1.5em; // height error message
  width: 100%;
  overflow: hidden;
`

export const PINCodeInputSC = styled.form<{
  direction?: PopupDirection
  rowGap?: FIXED_INDENTS
  invalid?: boolean
  disabled?: boolean
  colorDefault?: COLOR
  colorDisabled?: COLOR
  colorError?: COLOR
}>`
  display: flex;
  flex-direction: ${({ direction }) => direction || PopupDirection.Column};
  row-gap: ${({ rowGap }) => `var(${rowGap})`};
  justify-content: center;
  align-items: center;

  & ${TextBoxSC} {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;

    color: ${({
      colorDefault = COLOR.TEXT_ICON_SECONDARY,
      colorError,
      invalid,
      disabled,
    }) =>
      disabled
        ? `var(${colorError})`
        : invalid
          ? `var(${colorError})`
          : `var(${colorDefault})`};
  }
`

export const PINCodeInputWrapper = styled.div<IPINCodeInput>`
  display: flex;
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
  column-gap: ${({ columnGap }) => `var(${columnGap})`};
  justify-content: center;
`
export const PINCodeFieldSC = styled.input<
  IPINCodeField & {
    active: boolean
  }
>`
  background-color: ${({ backgroundColorDefault }) =>
    `var(${backgroundColorDefault})`};
  border: ${({ borders }) => `var(${borders}) solid var(${COLOR.TRANSPARENT})`};
  color: ${({ disabled, colorDisabled, colorDefault }) =>
    disabled
      ? `var(${colorDisabled})`
      : colorDefault
        ? `var(${colorDefault})`
        : 'inherit'};
  outline: 0;
  border-width: ${({ borders }) => `0 0 var(${borders})`};
  border-color: ${({
    invalid,
    active,
    borderColorDefault,
    borderColorPressed,
    borderColorInvalid,
  }) =>
    invalid
      ? `var(${borderColorInvalid})`
      : active
        ? `var(${borderColorPressed})`
        : `var(${borderColorDefault})`};
  width: 40px;
  height: 40px;
  font: ${({ font }) => `var(${font})`};
  text-align: center;

  &:focus {
    background-color: ${({ backgroundColorPressed }) =>
      `var(${backgroundColorPressed})`};
    border-bottom-color: ${({
      invalid,
      borderColorInvalid,
      borderColorPressed,
    }) =>
      invalid ? `var(${borderColorInvalid})` : `var(${borderColorPressed})`};
  }
`
